// assets/ck-koi-variety.js
// Keeps the per-variant regions of the PDP in sync with the selected
// variant: the koi-attributes "Variety", "Size", "Age", "Sex", "Scales" and
// "Pattern" rows.
//
// Dawn's product-info.js only swaps a fixed set of ids (price, Sku, Inventory,
// …) on variant change; none of these regions are among them. For group koi
// each variant is a different fish/variety, so they must follow the selection.
// We reuse the authoritative, freshly re-rendered section HTML that
// product-info.js carries on the variantChange event and copy each
// #<prefix>-<sectionId> container out of it into the live DOM.
//
// NOTE: `subscribe` / `PUB_SUB_EVENTS` are top-level const/function bindings
// from constants.js / pubsub.js. const does NOT attach to window, so they must
// be referenced by bare identifier (same pattern as ck-koi-ui-state.js).
(() => {
  if (window.__CK_KOI_VARIETY__) return;
  window.__CK_KOI_VARIETY__ = true;

  const ID_PREFIXES = ['KoiVariety', 'KoiSize', 'KoiAge', 'KoiSex', 'KoiScales', 'KoiPattern'];

  function syncRegion(prefix, data) {
    const id = `${prefix}-${data.sectionId}`;
    const dest = document.getElementById(id);
    if (!dest) return;

    const src = typeof data.html.getElementById === 'function'
      ? data.html.getElementById(id)
      : null;

    if (src) {
      dest.innerHTML = src.innerHTML;
      dest.hidden = src.hidden;
    } else {
      // New variant has no variety reference — collapse the region.
      dest.innerHTML = '';
      dest.hidden = true;
    }
  }

  function syncVariety(event) {
    const data = event && event.data;
    if (!data || !data.html || data.sectionId == null) return;
    ID_PREFIXES.forEach((prefix) => syncRegion(prefix, data));
  }

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, syncVariety);
    } else {
      console.warn('[CK-KOI-VARIETY] subscribe/PUB_SUB_EVENTS unavailable — variety sync not registered');
    }
  } catch (e) {
    console.error('[CK-KOI-VARIETY] failed to subscribe to variantChange:', e);
  }
})();
